import { OperationHistoryTemplate } from "@edp-models/operation-history.model";
import { Action } from "@ngrx/store";

export enum EOperationsActions {
    GetOperations = "[Operations] Get Operations",
    SetOperations = "[Operations] Set Operations",
}

export class GetOperations implements Action {
    public readonly type = EOperationsActions.GetOperations;
}

export class SetOperations implements Action {
    public readonly type = EOperationsActions.SetOperations;
    constructor(public payload: OperationHistoryTemplate[]) {}
}

export type OperationsActions = GetOperations | SetOperations;
